module.exports = __webpack_public_path__ + "static/media/50n.cf329b13.png";